<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">{{ data.header }}</div>
    <div class="modal-body">
      <div class="files-table-scroll">
        <table class="cl-table-data cl-table-data-light">
          <thead>
            <tr>
              @if (encodesList(); as encodes) {
                @if (encodes.length > 0 && encodes.some(f => canDownload(f))) {
                  <th class="cl-table-head cl-table-head-checkbox">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input"
                          aria-label="Select all downloadable files"
                          [checked]="isAllSelected(encodes)"
                          [indeterminate]="isIndeterminate(encodes)"
                          (change)="toggleAll(encodes)"/>
                    </div>
                  </th>
                }
              }
              <th class="cl-table-head">
                Filename
              </th>
              <th class="cl-table-head cl-th-currency">
                Size
              </th>
              <th class="cl-table-head">
                Last Modified
              </th>
              <th class="cl-table-head cl-th-links"></th>
            </tr>
          </thead>
          @if (encodesList(); as encodes) {
            <tbody>
              <tr appLoadRow [state]="errorState()" thing="encodes"></tr>
              @if (encodes.length > 0) {
                @for (file of encodes; track file) {
                  <tr [class.cl-faded]="renameInflight() === file.id || deleteInflight() === file.id">
                    @if (canDownload(file)) {
                      <td class="cl-td-checkbox">
                        <div class="form-check">
                          <input type="checkbox" class="form-check-input"
                              aria-label="Select {{ file.name }}"
                              [checked]="selection.isSelected(file)"
                              (change)="selection.toggle(file)"/>
                        </div>
                      </td>
                    }
                    <td>
                      @if (editingId === file.id) {
                        <input type="text" class="form-control form-control-sm"
                              [(ngModel)]="editingName"
                              [disabled]="renameInflight() === file.id"
                              (keyup.enter)="saveRename(file)"
                              (keyup.escape)="cancelRename()" />
                      } @else {
                        @if (renameInflight() === file.id || deleteInflight() === file.id) {
                          <span><i class="fas fa-spinner fa-spin"></i> {{ file.name }}</span>
                        } @else {
                          {{ file.name }}
                          @if (zipFailures().get(file.id); as reason) {
                            <span class="cl-badge cl-badge-sm cl-color-brick"
                                title="Failed to include in zip download: {{ reason }}. Use Download to retry.">
                              Failed
                            </span>
                          }
                        }
                      }
                    </td>
                    <td class="cl-td-currency">
                      {{ file.size | fileSize }}
                    </td>
                    <td class="cl-td-time">
                      <app-date [value]="file.last_modified" />
                    </td>
                    <td class="cl-td-links" width="1%">
                      @if (editingId === file.id) {
                        <a class="cl-a-btn cl-a-primary" role="button"
                          [class.cl-a-disabled]="renameInflight() === file.id"
                          [class.cl-a-spinner]="renameInflight() === file.id"
                          (click)="saveRename(file)">Save</a>
                        <a class="cl-a-btn" role="button"
                          [class.cl-a-disabled]="renameInflight() === file.id"
                          (click)="cancelRename()">Cancel</a>
                      } @else if (deleteConfirmId === file.id) {
                        <span class="cl-text-danger">Delete?</span>
                        <a class="cl-a-btn cl-a-danger" role="button" (click)="deleteEncode(file)">Confirm</a>
                        <a class="cl-a-btn" role="button" (click)="cancelDelete()">Cancel</a>
                      } @else {
                        @if (canDownload(file)) {
                          <a class="cl-a-btn cl-a-primary" role="button" (click)="download(file)">Download</a>
                        }
                        @if (canRename(file)) {
                          <a class="cl-a-btn cl-a-primary" role="button" (click)="startRename(file)">Rename</a>
                        }
                        <a class="cl-a-btn cl-a-primary" role="button" (click)="confirmDelete(file)">Delete</a>
                      }
                    </td>
                  </tr>
                }
              } @else if (!loadError()) {
                <tr class="cl-tr-no-data">
                  <td colspan="100">No encodes available. Please wait for encodes to finish.</td>
                </tr>
              }
            </tbody>
          } @else {
            <tbody>
              <tr class="cl-tr-no-data">
                <td colspan="100"><div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div></td>
              </tr>
            </tbody>
          }

        </table>
      </div>
    </div>
    <div class="modal-footer">
      <span class="modal-footer-left cl-spacing-box cl-spacing-none">
        <button type="button" class="btn cl-color-secondary it-ok"
          (click)="dialogRef.close();">
          <span>Close</span>
        </button>
      </span>
      <span class="modal-footer-center cl-spacing-box cl-spacing-none">
        @if (zipProgress(); as progress) {
          <p class="cl-p-small mt-4">Downloading {{ progress.done }} / {{ progress.total }}</p>
        }
      </span>
      <span class="modal-footer-right cl-spacing-box cl-spacing-none">
        @if (encodesList(); as encodes) {
          @if (encodes.length > 0 && encodes.some(f => canDownload(f))) {
            <button type="button" class="btn cl-color-primary"
              [class.cl-btn-spinner]="zipInflight()"
              [disabled]="selection.selected.length === 0 || zipInflight()"
              (click)="downloadSelectedAsZip(selection.selected)">
              <span>Download selected ({{ selection.selected.length }})</span>
            </button>
          }
        }
      </span>
    </div>
  </div>
</div>
